import { RULESET as i, KEYFRAMES as c, COMMENT as u, DECLARATION as l, IMPORT as f, LAYER as o } from "./index.es94.js";
import { strlen as t } from "./index.es135.js";
function s(e, r) {
  for (var n = "", a = 0; a < e.length; a++)
    n += r(e[a], a, e, r) || "";
  return n;
}
function h(e, r, n, a) {
  switch (e.type) {
    case o:
      if (e.children.length) break;
    case f:
    case l:
      return e.return = e.return || e.value;
    case u:
      return "";
    case c:
      return e.return = e.value + "{" + s(e.children, a) + "}";
    case i:
      if (!t(e.value = e.props.join(","))) return "";
  }
  return t(n = s(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
export {
  s as serialize,
  h as stringify
};
//# sourceMappingURL=index.es96.js.map
